import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { semesterValue } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

const VerifyStudentMobile = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    if (context.getStorage("update_stu_profile") == "yes") {
      navigate("/stu/update-profile");
    }
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (mobile.length != 10) {
      Toast.show({ content: "Enter 10 digit mobile number" });
      return;
    }
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.GET_OTP_FOR_PROFILE_UPDATE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          navigate("/stu/verify-otp", { state: d });
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  const stateField = (fieldName) => {
    return location.state?.[fieldName];
  };

  return (
    <>
      <Header
        title="Update Profile"
        backAction={[]}
        rightActions={[]}
        onBack={(e) => navigate("/stu/register")}
      />

      <div className="page-content-wrapper">
        <div className="container py-3">
          <Form
            action=""
            method="post"
            noValidate
            validated={validated}
            onSubmit={handleFormSubmit}
          >
            <input type="hidden" name="uuid" value={stateField("uuid")} />
            <input
              type="hidden"
              name="registerno"
              value={stateField("registerno")}
            />

            <div className="billing-information-card mb-3 mt-2">
              <div className="card billing-information-title-card bg-danger">
                <div className="card-body">
                  <h6 className="text-center mb-0 text-white">
                    Student Detail
                  </h6>
                </div>
              </div>
              <div className="card user-data-card">
                <div className="card-body">
                  <div className="single-profile-data d-flex align-items-center justify-content-between">
                    <div className="title d-flex align-items-center">
                      <i className="fa-solid fa-user"></i>
                    </div>
                    <div className="data-content">{stateField("name")}</div>
                  </div>
                  <div className="single-profile-data d-flex align-items-center justify-content-between">
                    <div className="title d-flex align-items-center">
                      <i className="fa-regular fa-note-sticky"></i>
                    </div>
                    <div className="data-content">
                      {stateField("registerno")}
                    </div>
                  </div>
                  <div className="single-profile-data d-flex align-items-center justify-content-between">
                    <div className="title d-flex align-items-center">
                      <i className="fa-solid fa-book"></i>
                    </div>
                    <div className="data-content">
                      {stateField("degree_name")}-{stateField("course_name")}
                    </div>
                  </div>
                  <div className="single-profile-data d-flex align-items-center justify-content-between">
                    <div className="title d-flex align-items-center">
                      <i className="fa-solid fa-quote-left"></i>
                    </div>
                    <div className="data-content">
                      {semesterValue(stateField("semester"))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="billing-information-card mb-3">
              <div className="card billing-information-title-card bg-success">
                <div className="card-body">
                  <h6 className="text-center mb-0 text-white">
                    Verify Mobile Number
                  </h6>
                </div>
              </div>
              <div className="card user-data-card">
                <div className="card-body">
                  <Row className="mt-2">
                    <Col md={12}>
                      <Form.Control
                        type="number"
                        size="sm"
                        className="fw-bold"
                        name="mobile"
                        placeholder="Enter Your Mobile Number"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col md={12}>
                      <Button
                        type="submit"
                        variant="warning"
                        className="w-100"
                        size="lg"
                        disabled={mobile.length != 10}
                      >
                        Get OTP
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};
export default VerifyStudentMobile;
